module.exports = __webpack_public_path__ + "static/media/MontserratAlternates-Regular.778e16de.ttf";